export const SUBMIT_CATEGORY_TR_FORM = 'categoryTRForm/SUBMIT_CATEGORY_TR_FORM';
export const LOAD_FORM = 'categoryForm/LOAD_FORM';
